import { Checkbox, FormField, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import { useEffect, useMemo, useState } from 'react';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../commons/functions';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiCheckCircle, mdiDeleteAlert, mdiLightbulbOn, mdiLightbulbOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { useGlobalState } from '../../../context/GlobalStateContext';


export const MasterAccounts = () => {

    type ItemAccountPlan = {
        idAccountPlan: number;
        users: number;
        transferCPV: number;
        transferCPS: number;
        isActiveAccountPlan: number;
        isDeleteAccountPlan: number;
        isCostCenter: number;
        isAux: number;
        accountPlan: string;
        codeAccountPlan: string;
        codeAccountPlanSoftland: string;
        CCO: string;

    }

    type ItemCharge = {
        idCharge: number,
        users: number,
        isActiveCharge: number,
        isDeleteCharge: number,
        ammount: number,
        currency: string,
        charge: string,
        accountPlan: string,
        account: string,
        isPAC: number,
    };


    //const storeAdmin = useStoreAdmin();

    const { menu, parameters } = useGlobalState();
    const [sideOpen, setSideOpen] = useState(false);
    const [showInactives, setShowInactives] = useState(false);
    const [showDeleted, setShowDeleted] = useState(false);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();




    const [accountPlans, setAccountPlans] = useState<ItemAccountPlan[]>([])
    const [accountPlan, setAccountPlan] = useState<ItemAccountPlan>()

    const [filteringText, setFilteringText] = useState("")

    const filtered = useMemo(() => {
        //if (!filterAccountsPlans.trim()) return accountPlans;
        let filtered = accountPlans;
        if (!showDeleted) {
            filtered = filtered.filter(item => item.isDeleteAccountPlan === 0);
        }

        // ✅ Handle Inactive filter
        if (!showInactives) {
            filtered = filtered.filter(item => item.isActiveAccountPlan === 1);

        }
        if (filteringText.trim()) {
            const terms = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
            filtered = filtered.filter(item => {
                const haystack = [
                    item.accountPlan ?? "",
                    item.codeAccountPlanSoftland ?? "",
                    item.idAccountPlan.toString(),
                ].join(" ").toLowerCase();

                return terms.every(term => haystack.includes(term));
            });
        }

        return filtered;
    }, [accountPlans, filteringText, showInactives, showDeleted]);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const paginated: ItemAccountPlan[] = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    const handleGetAccountPlans = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/accountplans/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.accountPlans)
                setAccountPlans(data.accountPlans)

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleGetAccountPlans()
    }, []);
    //
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                            counter={filteringText === "" ? accountPlans.length ? `(${accountPlans.length})` : "" : `${filtered.length} de ${accountPlans.length}`}
                        >Cuentas</Header>
                        <Table<ItemAccountPlan>
                            stickyHeader
                            variant='embedded'
                            filter={
                                <FormField
                                    constraintText={
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <Checkbox checked={showInactives} onChange={(event) => setShowInactives(event.detail.checked)}>Mostrar inactivos</Checkbox>
                                            <Checkbox checked={showDeleted} onChange={(event) => setShowDeleted(event.detail.checked)}>Mostrar eliminados</Checkbox>
                                        </SpaceBetween>
                                    }
                                >
                                    <TextFilter
                                        filteringText={filteringText}
                                        filteringPlaceholder="Buscar..."
                                        onChange={({ detail }) => setFilteringText(detail.filteringText)}
                                    />
                                </FormField>
                            }

                            pagination={
                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {accountPlans.length > 0 && accountPlans.length > parameters.pageSize && (

                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>

                            }


                            columnDefinitions={[
                                {
                                    id: "idAccountPlan", header: "ID", cell: item => item?.idAccountPlan, width: 80
                                },
                                {
                                    id: "account", header: "Cuenta", cell: item => item?.accountPlan,
                                },
                                {
                                    id: "code", header: "PDC",
                                    cell: item => (
                                        <FormField label={item.codeAccountPlan}>
                                            {item.codeAccountPlanSoftland}
                                        </FormField>
                                    )
                                },
                                {
                                    id: "CPVCPV", header: "CPV<>CPS", cell: item => `${item.transferCPV * 100}%/${item.transferCPS * 100}%`
                                },
                                {
                                    id: "CCO", header: "CCO", cell: item => item.CCO
                                },
                                {
                                    id: "isAux", header: "AUX", cell: item => (
                                        <>
                                            {item.isAux === 1 ? <Icon path={mdiCheckCircle} size={1} /> : ""}
                                        </>
                                    )
                                },
                                {
                                    id: "isActiveAccountPlan", header: "",
                                    width: 50,
                                    cell: item => (

                                        <>
                                            {item.isActiveAccountPlan === 1 ?
                                                <Icon path={mdiLightbulbOn} color={"#f7c302"} size={1} /> :
                                                <Icon path={mdiLightbulbOutline} color={"#ddd"} size={1} />
                                            }
                                        </>

                                    )
                                },
                                {
                                    id: "isDeleteAccountPlan", header: "",
                                    width: 50,
                                    cell: item => (
                                        <>
                                            {item.isDeleteAccountPlan === 1 ? <Icon path={mdiDeleteAlert} color={"red"} size={1} /> : ""}
                                        </>
                                    )
                                },
                            ]}
                            items={(paginated as ItemAccountPlan[]) ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin plan de cuentas asociado</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                    </SpaceBetween>

                </>
            }
        />
    );
};